import Login from "./AuthPages/Login/Index";
import Otp from "./AuthPages/Otp/Index";
import SignUp from "./AuthPages/Signup/Index";
import ForgotPassword from "./AuthPages/forgotPassword/Index";
import ResetPassword from "./AuthPages/resetPassword/Index";
import CharacterSetting from "./SideTabPages/CharacterSetting";
import CharacterView from "./SideTabPages/CharacterSetting/View";
import ContentPage from "./SideTabPages/ContentPage";
import Dashboard from "./SideTabPages/Dashboard";
import FAQ from "./SideTabPages/FAQ";
import Language from "./SideTabPages/Language";
import Profile from "./SideTabPages/Profile";
import Setting from "./SideTabPages/Setting";
import Subscsription from "./SideTabPages/Subscription";
import TokenPackage from "./SideTabPages/TokenPackage";
import ManageUsers from "./SideTabPages/Users";
import AddSubscription from "./SideTabPages/Subscription/add";
import SubscriptionDetail from "./SideTabPages/Subscription/detail";
import EditSubscription from "./SideTabPages/Subscription/edit";
import Transaction from "./SideTabPages/Transaction";
import UserView from "./SideTabPages/Users/detail";
import PublicCharacter from "./SideTabPages/CharacterManage/PublicCharacter";
import PersionalCharacter from "./SideTabPages/CharacterManage/PersionalCharacter";
import ManageTags from "./SideTabPages/TagsManage";
import AddCharacterType from "./SideTabPages/CharacterSetting/Add";
import EditCharacterType from "./SideTabPages/CharacterSetting/edit";
import AddTags from "./SideTabPages/TagsManage/addTags";
import EditTags from "./SideTabPages/TagsManage/editTags";
import HomePage from "./SideTabPages/HomePage";
import AddHome from "./SideTabPages/HomePage/add";
import EditHome from "./SideTabPages/HomePage/edit";
import FaqCategory from "./SideTabPages/FaqCategory";
import PersonalView from "./SideTabPages/CharacterManage/PersionalCharacter/DetailsPersonal";
import PublicView from "./SideTabPages/CharacterManage/PublicCharacter/DetailsPublic";
import UserRevenue from "./SideTabPages/Revenue/UserRevenue";
import SysytemAccess from "./SideTabPages/SystemAccess/List";
import ViewCharacterRevenue from "./SideTabPages/Revenue/UserRevenue/detail";
import UserTransactionPage from "./SideTabPages/Payments/UserTransaction";
import SubscriptionPayment from "./SideTabPages/Payments/SubscriptionPayment";
import TokenPayments from "./SideTabPages/Payments/TokenPayment";
import AddUser from "./SideTabPages/Users/add";
import AddSubUser from "./SideTabPages/SystemAccess/Add/addSubuser";
import MakeCharacterPublic from "./SideTabPages/CharacterManage/MakeCharacterPublic";
// import CreateAi from "./SideTabPages/new-create-ai";
import CreateAi from "./SideTabPages/create-ai";
import BlogPage from "./SideTabPages/BlogPage";
import BlogCategory from "./SideTabPages/BlogCategory";
import GiftPage from "./SideTabPages/GiftPage";
import FlagMessagePage from "./SideTabPages/FlagMessages";
import FlagMessageDetail from "./SideTabPages/FlagMessages/detail/index";
import ContactForm from "./SideTabPages/ContactForm";
import FormDetail from "./SideTabPages/ContactForm/detail/index";
import CommonSelectionComponent from "./SideTabPages/CompanionSelection/index";
import BelovedCharacter from "./SideTabPages/CharacterManage/BelovedRealistic";
import BelovedView from "./SideTabPages/CharacterManage/BelovedRealistic/DetailBeloved";
import PromoCode from "./SideTabPages/PromoCode";
import RequsetedCharaterDetail from "./SideTabPages/CharacterManage/MakeCharacterPublic/DetailsPublic/index";
import FeatureSetting from "./SideTabPages/FeatureSetting";
import InfluencerList from "./SideTabPages/Influencer/List";
import InfluencerDetail from "./SideTabPages/Influencer/Detail";
import Tokens from "./SideTabPages/Tokens";
import AddTokenPlan from "./SideTabPages/Tokens/add";
import EditTokenPlan from "./SideTabPages/Tokens/edit";
import InfluencerWithdraw from "./SideTabPages/InfluencerWithdraw/List";

export const routes = [
  { path: "/login", component: <Login /> },
  { path: "/signup", component: <SignUp /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/otp", component: <Otp /> },
  { path: "/reset-password", component: <ResetPassword /> },
];

export const privateRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/subscription-setting", component: <Subscsription /> },
  { path: "/subscription-plan/add", component: <AddSubscription /> },
  { path: "/subscription-plan/:id", component: <EditSubscription /> },
  { path: "/tokens-setting", component: <Tokens /> },
  { path: "/tokens-plan/add", component: <AddTokenPlan /> },
  { path: "/tokens-plan/:id", component: <EditTokenPlan /> },
  { path: "/user", component: <ManageUsers /> },
  { path: "/user/add", component: <AddUser /> },
  { path: "/user/:id", component: <UserView /> },
  { path: "/page", component: <ContentPage /> },
  { path: "/faq", component: <FAQ /> },
  { path: "/feature-setting", component: <FeatureSetting /> },
  { path: "/subscription-plan/detail/:id", component: <SubscriptionDetail /> },
  { path: "/profile", component: <Profile /> },
  { path: "/setting", component: <Setting /> },
  { path: "/token", component: <TokenPackage /> },
  { path: "/homepage", component: <HomePage /> },
  { path: "/homepage/add", component: <AddHome /> },
  { path: "/homepage/:id", component: <EditHome /> },
  { path: "/character-setting", component: <CharacterSetting /> },
  { path: "/character-setting/add", component: <AddCharacterType /> },
  { path: "/character-setting/:id", component: <EditCharacterType /> },
  { path: "/public-character", component: <PublicCharacter /> },
  { path: "/public-character/:id", component: <PublicView /> },
  { path: "/beloved-character", component: <BelovedCharacter /> },
  { path: "/beloved-character/:id", component: <BelovedView /> },
  { path: "/persional-character", component: <PersionalCharacter /> },
  { path: "/persional-character/:id", component: <PersonalView /> },
  { path: "/transaction", component: <Transaction /> },
  { path: "/character-setting/:id", component: <CharacterView /> },
  { path: "/language", component: <Language /> },
  { path: "/tags", component: <ManageTags /> },
  { path: "/tags/add", component: <AddTags /> },
  { path: "/tags/:id", component: <EditTags /> },
  { path: "/faqcategory", component: <FaqCategory /> },
  { path: "/revenue", component: <UserRevenue /> },
  { path: "/revenue/:id", component: <ViewCharacterRevenue /> },
  { path: "/user-transaction", component: <UserTransactionPage /> },
  { path: "/subscription-payment", component: <SubscriptionPayment /> },
  { path: "/token-payment", component: <TokenPayments /> },
  { path: "/access", component: <SysytemAccess /> },
  { path: "/access/add", component: <AddSubUser /> },
  { path: "/make-character-public", component: <MakeCharacterPublic /> },
  { path: "/create-ai", component: <CreateAi /> },
  { path: "/blog", component: <BlogPage /> },
  { path: "/blog-category", component: <BlogCategory /> },
  { path: "/gift", component: <GiftPage /> },
  { path: "/flag-message", component: <FlagMessagePage /> },
  { path: "/flag-message/detail", component: <FlagMessageDetail /> },
  { path: "/contact-forms", component: <ContactForm /> },
  { path: "/contact-forms/:id", component: <FormDetail /> },
  { path: "/companion-selection", component: <CommonSelectionComponent /> },
  { path: "/promo-code", component: <PromoCode /> },
  {
    path: "/make-character-public/:id",
    component: <RequsetedCharaterDetail />,
  },
  { path: "/influencer/list", component: <InfluencerList /> },
  { path: "/influencer/list/:id", component: <InfluencerDetail /> },
  { path: "/influencer/withdrawals", component: <InfluencerWithdraw /> },
];
